/** @format */

// project
import { http } from "@/http";

export const deleteWidget = async (studyId: string, widgetId: string) => {
	await http.delete(`studies/${studyId}/analytics/widgets/${widgetId}`);
};